import { useMutation, useQueryClient } from '@tanstack/react-query';

import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';

export const useSaveForumPost = (id: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (saved: boolean) => {
      return fetchJson(saved ? `/forum/posts/${id}/bookmark` : `/forum/posts/${id}/unbookmark`, {
        method: 'POST',
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QueryKeys.forum.show.id(id) });
      queryClient.invalidateQueries({ queryKey: QueryKeys.forum.index.root });
    },
  });
};
